module.exports = __webpack_public_path__ + "img/icon-location-light.d1e3a212.svg";